export const CATERING_PATH = '/order-catering';
export const FOUNDATION_PATH = '/public-safety-foundation';
export const CAREERS_PATH = 'https://careers.firehousesubs.ca';
